import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class LoginAuthGuard implements CanActivate {

    constructor(
    ) { }

    canActivate(): boolean {
        if (localStorage.getItem('loggedInUser')) {
            return false;
        } else {
            return true;
        }
    }

}
